import {Icon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "7",
  viewBox: "0 0 16 7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M0.160028985,9 L0,9 C3.64250967e-15,6.23857625 3.581722,4 8,4 C12.418278,4 16,6.23857625 16,9 L15.839971,9 C15.9449116,9.32310994 16,9.65753416 16,10 L14,10 C14,8.59156996 11.4534881,7 8,7 C4.54651194,7 2,8.59156996 2,10 L0,10 C3.64250967e-15,9.65753416 0.055088415,9.32310994 0.160028985,9 L0.160028985,9 Z M12,10 L12,6 L14,6 L14,9 L16,9 L16,10 C16,10.5522847 15.5522847,11 15,11 L13,11 C12.4477153,11 12,10.5522847 12,10 Z M4,10 C4,10.5522847 3.55228475,11 3,11 L1,11 C0.44771525,11 6.79358677e-15,10.5522847 1.04360964e-14,10 L1.04360964e-14,9 L2,9 L2,6 L4,6 L4,10 L4,10 Z",
      transform: "translate(0 -4)"
    }, null, -1)
  ]))]))
}
export default { render() { return h(Icon, {icon: {render}, name: "icon-phone-cancel"}) } }